import { useEffect, useState } from "react";
import { Users, Timer } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";

const SeatTime = ({ data }) => {
  const today = data.days[data.days.length - 1]?.minutes || 0;
  const max = Math.max(data.goal_minutes, ...data.days.map((d) => d.minutes));
  return (
    <div className="rounded-3xl bg-white/60 border border-[#E6DEC3] p-6" data-testid="seat-time-card">
      <p className="text-xs uppercase tracking-widest text-stone-500 inline-flex items-center gap-1.5"><Timer className="w-3.5 h-3.5 text-[#C87D53]" />Active learning today</p>
      <p className="font-display text-3xl text-[#2C4A3E] mt-2" data-testid="seat-time-today">{today} <span className="text-base text-stone-500">/ {data.goal_minutes} min</span></p>
      <div className="flex items-end gap-1 h-16 mt-4">
        {data.days.map((d) => (
          <div key={d.date} title={`${d.date}: ${d.minutes} min`} className={`flex-1 rounded-t ${d.minutes >= data.goal_minutes ? "bg-[#6B9080]" : "bg-[#E6DEC3]"}`}
            style={{ height: `${Math.max(4, (d.minutes / max) * 100)}%` }} />
        ))}
      </div>
      <p className="text-xs text-stone-500 mt-2">Last 14 days · green = attendance goal met</p>
    </div>
  );
};

export const MyClasses = () => {
  const [classes, setClasses] = useState(null);
  const [activity, setActivity] = useState(null);
  const [code, setCode] = useState("");
  const load = () => {
    http.get("/classes").then((r) => setClasses(r.data)).catch(() => {});
    http.get("/activity/me").then((r) => setActivity(r.data)).catch(() => {});
  };
  useEffect(load, []);

  const join = async (e) => {
    e.preventDefault();
    try {
      const r = await http.post("/classes/join", { code });
      toast.success(`Joined ${r.data.name}`); setCode(""); load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="grid md:grid-cols-2 gap-5">
      {activity && <SeatTime data={activity} />}
      <div className="rounded-3xl bg-white/60 border border-[#E6DEC3] p-6" data-testid="my-classes-card">
        <p className="text-xs uppercase tracking-widest text-stone-500 inline-flex items-center gap-1.5"><Users className="w-3.5 h-3.5 text-[#C87D53]" />My classes</p>
        <ul className="mt-3 space-y-2">
          {classes?.map((c) => (
            <li key={c.id} className="flex justify-between text-sm" data-testid={`my-class-${c.id}`}><b className="text-[#2C4A3E]">{c.name}</b><span className="text-stone-500">{c.teacher_name}</span></li>
          ))}
          {classes === null && <li className="text-sm text-stone-400">Loading…</li>}
          {classes?.length === 0 && <li className="text-sm text-stone-500">Not in a class yet.</li>}
        </ul>
        <form onSubmit={join} className="flex gap-2 mt-4">
          <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="Class code" data-testid="join-class-input"
            className="flex-1 px-4 py-2 rounded-full bg-white border border-[#E6DEC3] uppercase text-sm focus:outline-none focus:border-[#2C4A3E]" />
          <button type="submit" disabled={code.trim().length < 4} data-testid="join-class-btn" className="px-5 py-2 rounded-full bg-[#2C4A3E] text-white text-sm disabled:opacity-50">Join</button>
        </form>
      </div>
    </div>
  );
};
